import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { workflowSetIsTurnTrackingEnabled } from '~/actions/workflow';
import { Checkbox } from '~/eds/src/components/Checkbox/Checkbox';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { selectIsTurnTrackingEnabled } from '~/redux/selectors';
import { Nullable } from '~/types/Nullable';

export const CycleTimeTracker = () => {
  const intl = useIntl();
  const isTurnTrackingEnabled = useSelector(selectIsTurnTrackingEnabled);
  const dispatch = useDispatch();

  const handleOnChange = (value: Nullable<boolean>) => {
    dispatch(workflowSetIsTurnTrackingEnabled(Boolean(value)));
  };
  return (
    <ContentContainer>
      <Layout direction="column">
        <Layout direction="row" spacing={2} align="center">
          <Icon icon="turn-tracking" size="l" color="status.active" />
          <Text variant="section">
            <FormattedMessage
              id="CycleTimeTracker.sectionTitle"
              defaultMessage="Cycle Time Tracker"
              description="Title for cycle time tracker section"
            />
          </Text>
        </Layout>
        <Text variant="body" color="text.quiet" mb={4} mt={2}>
          <FormattedMessage
            id="CycleTimeTracker.sectionDescription"
            defaultMessage="Display Cycle Time Tracking on the Intake Form, allowing users to set a Responsible Party when creating a ticket."
            description="Description for cycle time tracker section"
          />
        </Text>
        <Layout>
          <Checkbox
            option={{
              value: 'isTurnTrackingEnabled',
              label: intl.formatMessage({
                id: 'CycleTimeTracker.enableLabel',
                defaultMessage: 'Enable cycle time tracking',
                description: 'Label for enable cycle time tracking checkbox',
              }),
            }}
            value={isTurnTrackingEnabled}
            onChange={handleOnChange}
            name="toggleTurnTracking"
          />
        </Layout>
      </Layout>
    </ContentContainer>
  );
};
